import { render, staticRenderFns } from "./AreaPicker.vue?vue&type=template&id=2bb65b0f&scoped=true"
import script from "./AreaPicker.vue?vue&type=script&lang=js"
export * from "./AreaPicker.vue?vue&type=script&lang=js"
import style0 from "./AreaPicker.vue?vue&type=style&index=0&id=2bb65b0f&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb65b0f",
  null
  
)

export default component.exports